// @flow
import React from "react"
import { compose } from "react-apollo"
import { Prompt } from "react-router-dom"
import { Helmet } from "react-helmet"
import { Toolbar, Heading } from "../UI/Toolbar"
import { Page } from "../UI/Page"
import SensorForm from "./SensorForm"
import queries from "./queries"
import Loader from "../UI/Loader"
import type { SensorFormViewProps } from "./types"
import handleSubmit from "./handleSubmit"

type State = { isBlocking: boolean }
class SensorFormView extends React.Component<SensorFormViewProps, State> {
  constructor(props) {
    super(props)
    this.state = { isBlocking: false }
  }

  handleChange(e) {
    this.setState(() => ({ isBlocking: true }))
  }

  componentDidUpdate(prevProps, prevState) {
    const { details } = this.props
    if (
      prevProps.details &&
      prevProps.details.loading &&
      details &&
      !details.loading
    ) {
      this.setState(() => ({ isBlocking: false }))
    }
  }

  render() {
    const {
      updateSensor,
      history: { push },
      match: { params: { id } },
      details
    } = this.props
    const { isBlocking } = this.state

    return (
      <Page>
        <Helmet>
          <title>
            {`Sensors - ${details && details.sensor
              ? `${details.sensor.friendlyName || details.sensor.stationName}`
              : "New"}`}
          </title>
        </Helmet>
        <Prompt
          when={isBlocking}
          message={location =>
            `Are you sure you want to leave this form and lose any unsaved changes?`}
        />
        <Loader loading={details ? details.loading : false}>
          <Toolbar>
            <Heading>
              {details ? (
                `Editing: ${details.sensor
                  ? details.sensor.friendlyName || details.sensor.stationName
                  : ""}`
              ) : (
                ""
              )}
            </Heading>
          </Toolbar>
          <SensorForm
            loading={details ? details.loading : true}
            initialValues={details ? details.sensor : {}}
            onSubmit={handleSubmit(id, updateSensor, () => {
              this.setState(() => ({ isBlocking: false }))
              push("/admin/sensors")
            })}
            onChange={e => this.handleChange(e)}
            handleCancel={event => {
              event.preventDefault()
              push("/admin/sensors")
            }}
            id={id}
          />
        </Loader>
      </Page>
    )
  }
}

export default compose(
  queries.withSensorFormDetails,
  queries.mutateUpdateSensor
)(SensorFormView)



// WEBPACK FOOTER //
// ./src/Sensors/SensorFormView.js